import { AxiosError } from 'axios';
import { notification } from 'antd';

export interface WorkOrderErrorResponse {
  message: string;
  name: string;
  description: string;
  fieldErrors: {
    CustomerId?: string[];
    InsurerId?: string[];
    CompanyId?: string[];
  };
}

interface Props {
  error: unknown;
  messageDefault: (error: AxiosError) => void;
}

export default function notificationFieldErrorWorkOrder({
  error,
  messageDefault,
}: Props) {
  const err = error as AxiosError<WorkOrderErrorResponse>;

  const { fieldErrors } = err.response?.data || {};

  const showErrorNotification = (description: string | undefined) => {
    if (description?.length) {
      notification.error({
        message: 'Erro de vínculo',
        description,
      });
    }
  };

  showErrorNotification(fieldErrors?.CustomerId?.[0]);
  showErrorNotification(fieldErrors?.InsurerId?.[0]);
  showErrorNotification(fieldErrors?.CompanyId?.[0]);

  if (
    !fieldErrors?.CustomerId &&
    !fieldErrors?.InsurerId &&
    !fieldErrors?.CompanyId
  ) {
    messageDefault(err);
  }
}
